import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import WorkerWallet from "@/pages/WorkerWallet";
import QRVerify from "@/pages/QRVerify";
import EmployerDashboard from "@/pages/EmployerDashboard";
import ScanDemo from "@/pages/ScanDemo";
import AdminPortal from "@/pages/AdminPortal";

function App() {
  return (
    <div className="App min-h-screen bg-white text-[#0B1221]">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/wallet" element={<WorkerWallet />} />
          <Route path="/wallet/:workerId" element={<WorkerWallet />} />
          <Route path="/verify" element={<QRVerify />} />
          <Route path="/verify/:workerId" element={<QRVerify />} />
          <Route path="/scan" element={<ScanDemo />} />
          <Route path="/dashboard" element={<EmployerDashboard />} />
          <Route path="/admin" element={<AdminPortal />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
